<div class="spinner-overlay" *ngIf="isLoading">
  <nz-spin nzSpinning="true" nzSize="large">
    <div class="spinner-content">{{ spinnerContent }}</div>
  </nz-spin>
</div>

<div class="manage-charts-wrapper">
  <h3 nz-typography class="nfl-form-label">Manage Charts</h3>

  <div nz-row [nzGutter]="[12, 12]" nzAlign="middle">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label nzFor="sort" nzNoColon>Sort by</nz-form-label>
        <nz-form-control>
          <button nz-button nzType="default" nzSize="default" class="sort-button" (click)="toggleSortDirection()">
            <span>Last Modified</span>
            <span nz-icon [nzType]="sortDescending ? 'caret-down' : 'caret-up'" nzTheme="outline"></span>
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8" nzOffset="8">
      <nz-form-item>
        <nz-form-control>
          <nz-input-group [nzSuffix]="searchSuffix">
            <input
              nz-input
              placeholder="Search by name, chart type or owner"
              type="text"
              nzSize="default"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($any($event.target).value)"
            />
          </nz-input-group>
          <ng-template #searchSuffix>
            <span nz-icon nzType="search"></span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <nz-divider></nz-divider>

  <div class="charts-grid">
    <div nz-row [nzGutter]="[24, 24]">
      <div nz-col [nzSpan]="24" *ngIf="!isLoading && filteredCharts.length === 0">
        <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No charts found"> </nz-empty>
      </div>

      <div nz-col [nzSpan]="12" *ngFor="let chart of paginatedCharts; trackBy: trackByChartId">
        <app-data-preview [data]="chart" (menuAction)="onMenuAction($event)"></app-data-preview>
      </div>
    </div>

    <!-- Pagination -->
    <div class="pagination-container" *ngIf="!isLoading && filteredCharts.length > 0">
      <nz-pagination
        [nzPageIndex]="currentPage"
        [nzTotal]="total"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="true"
        [nzShowQuickJumper]="true"
        [nzShowTotal]="totalTemplate"
        [nzPageSizeOptions]="[4, 10, 20]"
        (nzPageIndexChange)="onPageChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      >
      </nz-pagination>

      <ng-template #totalTemplate let-total let-range="range">
        {{ range[0] }}-{{ range[1] }} of {{ total }} charts
      </ng-template>
    </div>
  </div>
</div>
